/** Module default imports */
import styles from './login-form.module.css';
import PhoneNumberLoginForm from './phone-number-login-form';
import EmailLoginForm from './email-login-form';

/** Module named imports */
import {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import {withRouter} from 'next/router';
import {withAlerts} from '@/contexts/alerts-context';
import {AuthMethod} from '@/data/auth-method';

/** Module type imports */
import type {WithRouterProps} from 'next/dist/client/with-router';
import type {WithAlertsProps} from '@/contexts/alerts-context';

type Props = WithAlertsProps & WithRouterProps;

interface State {
  readonly method: AuthMethod;
}

class LoginForm extends Component<Props, State> {
  public readonly state: State = {method: AuthMethod.PhoneNumber};

  public render(): JSX.Element {
    const {method} = this.state;

    return (
      <div className={styles.form_container}>
        <button className={styles.google_button} onClick={this.toggleAuthMethod}>
          {method === AuthMethod.Email ? (
            <FormattedMessage id="words.use_phone_number" />
          ) : (
            <FormattedMessage id="words.use_email" />
          )}
        </button>
        {method === AuthMethod.Email ? <EmailLoginForm /> : <PhoneNumberLoginForm />}
      </div>
    );
  }

  /** @internal */
  private toggleAuthMethod = () => {
    const {method} = this.state;
    this.setState({
      method: method === AuthMethod.Email ? AuthMethod.PhoneNumber : AuthMethod.Email,
    });
  };
}

export default withAlerts(withRouter(LoginForm));
